import classNames from "classnames";
import CircleIcon from "../../../elements/CircleIcon";

const QuickNoteLink = ({ sidebarOpen, setQuickNoteOpen, css }) => {
  return (
    <>
      <div
        className={classNames("px-2 py-1 d-flex sidebar-link link-hovered", {
          "justify-content-center": !sidebarOpen,
          [css]: !!css,
        })}
        onClick={() => setQuickNoteOpen(true)}
      >
        <CircleIcon icon="mdi mdi-plus" />
        {sidebarOpen && <div className="pl-2 mb-0">Quick Note</div>}
      </div>
    </>
  );
};

export default QuickNoteLink;
